<template>
  <nav class="accountants-menu" :class="{ horizontal: horizontal }">
    <div>
      <div class="accountants-menu--gklogo">
        <GkLogo :fill="logoColor" />
        <span>{{ $gettext('Accounting') }}</span>
      </div>
    </div>
    <div style="width: 100%; display: flex; justify-content: space-between; align-items: center;">
      <ul class="accountants-menu--menuitems" role="menu" aria-label="Accountants menu">
            
        <!-- Dashboard -->
        <li class="menuitem" role="none" :class="{ active: isDashboard }">
          <router-link
            role="menuitem"
            :to="{ name: 'AccountantsDashboard' }"
            data-analytics-click="menu home dashboard"
            :aria-current="isDashboard ? 'page' : null"
          >
            <div class="menuitem--icon">
              <font-awesome-icon :icon="[isDashboard ? 'fa-solid' : 'fa-regular', 'fa-home']" />
            </div>
            <span v-translate>Dashboard</span>
          </router-link>
        </li>
            
        <!-- Clients -->
        <li class="menuitem" role="none" :class="{ active: isClients }">
          <router-link
            role="menuitem"
            :to="{ name: 'Clients' }"
            data-analytics-click="menu clients"
            :aria-current="isClients ? 'page' : null"
          >
            <div class="menuitem--icon">
              <font-awesome-icon :icon="[isClients ? 'fa-solid' : 'fa-regular', 'fa-users']" />
            </div>
            <span v-translate>Clients</span>
          </router-link>
        </li>
        <!-- Communication -->
        <li class="menuitem" role="none" :class="{ active: currentPage.includes('communication') }">
          <router-link
            role="menuitem"
            :to="{ name: 'Communication' }"
            data-analytics-click="menu communication"
            :aria-current="currentPage.includes('communication') ? 'page' : null"
          >
            <div class="menuitem--icon">
              <font-awesome-icon
                :icon="[currentPage.includes('communication') ? 'fa-solid' : 'fa-regular', 'fa-comment']"
              />
            </div>
            <span v-translate>Comms</span>
          </router-link>
        </li>
        <!-- Ledger -->
        <li class="menuitem" role="none" :class="{ active: currentPage.includes('ledger') }">
          <router-link
            role="menuitem"
            :to="{ name: 'Ledger' }"
            data-analytics-click="menu ledger"
            :aria-current="currentPage.includes('ledger') ? 'page' : null"
          >
            <div class="menuitem--icon">
              <font-awesome-icon
                :icon="[currentPage.includes('ledger') ? 'fa-solid' : 'fa-regular', 'fa-shopping-cart']"
              />
            </div>
            <span v-translate>Ledger</span>
          </router-link>
        </li>
        <!-- Settings -->
        <li class="menuitem" role="none" :class="{ active: isSettings }">
          <router-link
            role="menuitem"
            :to="{ name: 'AccountantCompanySettings' }"
            data-analytics-click="menu settings"
            :aria-current="isSettings ? 'page' : null"
          >
            <div class="menuitem--icon">
              <font-awesome-icon :icon="[isSettings ? 'fa-solid' : 'fa-regular', 'fa-gears']" />
            </div>
            <span v-translate>Settings</span>
          </router-link>
        </li>
      </ul>
      <ul
        class="accountants-menu--menuitems avatar-menu"
        role="menu"
        aria-label="Accountants menu"
      >
        <li class="menuitem" role="none">
          <div>
            <div class="avatar-menu--companyname">{{ currentCompany.name }}</div>
            <div class="avatar-menu--username small">{{ currentUser.display_name }}</div>
          </div>
        </li>
        <!-- Avatar -->
        <li class="menuitem" role="none">
          <b-dropdown
            dropright
            no-caret
            variant="link"
            toggle-class="avatar-toggle"
            data-analytics-click="menu avatar dropdown"
            class="accountants-menu--avatar ui-dashboard-menu-dropdown"
          >
            <!-- Toggle content -->
            <template #button-content>
              <b-avatar
                v-if="currentCompany.accountant_branding && currentCompany.accountant_branding.logo"
                class="avatar-menu--avatar"
                :src="currentCompany.accountant_branding.logo ? currentCompany.accountant_branding.logo : ''"
                size="32px"
              />
            </template>

            <!-- menu options -->
            <b-dropdown-item :to="{ name: 'Clients' }" data-analytics-click="menu avatar dropdown: clients">
              <font-awesome-icon :icon="'fa-solid fa-users'" />
              <span>{{ $gettext('Clients') }}</span>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'AccountantCompanySettings' }" data-analytics-click="menu avatar dropdown: settings">
              <font-awesome-icon :icon="'fa-solid fa-gears'" />
              <span>{{ $gettext('Settings') }}</span>
            </b-dropdown-item>
            <b-dropdown-divider />
            <!-- Logout -->
            <b-dropdown-item :to="{ name: 'Logout' }" class="text-danger" data-analytics-click="menu avatar dropdown: logout">
              <font-awesome-icon icon="fa-solid fa-power-off" />
              <span>{{ $gettext('Logout') }}</span>
            </b-dropdown-item>
          </b-dropdown>
          
        </li>
      </ul>
    </div>

  </nav>
</template>
<script>
import { mapGetters } from 'vuex'
import GkLogo from '@/components/ui/GkLogo.vue'
export default {
  name: 'AccountantsMenu',
  components: { GkLogo },
  props: {
    logoColor: {
      type: String,
      default: 'brand',
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      currentCompany: 'main/getCurrentCompany',
      currentUser: 'main/getCurrentUser',
    }),
    routeClass() {
      return this.$route && this.$route.name ? this.$route.name.toLowerCase() : ''
    },
    currentPage() {
      return this.$route.path
    },
    isDashboard () {
      const dashboardPage = ['dashboard']
      return dashboardPage.some((segment) => this.currentPage.includes(segment))
    },
    isClients() {
      const clientsPages = ['clients', 'pending-invitations', 'control-panel']
      return clientsPages.some((segment) => this.currentPage.includes(segment))
    },
    isSettings() {
      const settingsPages = ['companies', 'profile', 'password']
      return settingsPages.some((segment) => this.currentPage.includes(segment))
    },
  },
  methods: {

  },
}
</script>

<style lang="scss">
  .accountants-menu--menuitems {
    &.avatar-menu {
      margin-top: auto !important;
      padding: 1rem 0 !important;

      display: flex;
      gap: 0.5rem !important;
      align-items: center;
      font-size: 14px;
      text-align: right;
      color: var(--text-hl-branding-color);

      .avatar-menu--companyname {
        font-family: $fontMedium;
      }
      .avatar-menu--username {
        // color: $colorTextSemi;
        opacity: 0.7;
      }
      .avatar-menu--avatar {
        &.b-avatar {
          outline: 1px solid var(--text-hl-branding-color);
        }
      }
    }
  }

  .accountants-menu--avatar { // dropdown
    display: flex;
    align-items: center;
    padding: 0;
    width: 100%;
    .avatar-toggle {
      border: 0 !important;
      padding: 0 !important;
      margin: 0 !important;
      &:hover {
        text-decoration: none;
      }
    }
    .gk-logo-g {
      width: 80%;
      height: 80%;
    }
    .dropdown-menu {
      padding: 0.25rem 0.5rem !important;
    }
  }
</style>
<style lang="scss" scoped>
.accountants-menu {
  display: flex;
  flex-direction: column;
  width: var(--accountants-menu-size);
  background: var(--branding-color);
  flex-shrink: 0;
  padding-top: 1rem;
  border-right: 1px solid $colorBorderDash;
  &.horizontal {
    display: flex;
    flex-direction: row;
    height: var(--accountants-menu-size);
    width: 100%;
    align-items: center;
    padding: 0 1rem;
    gap: 4rem;
    border: 0;
    .accountants-menu--menuitems {
      display: flex;
      gap: 2rem;
      .menuitem a {
        padding: 0;
      }
    }
  }
  &--gklogo {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding-right: 1rem;
    // margin-right: 1rem;
    // border-right: 1px solid #d7d7d7;
    svg {
      height: 34px;
    }
    span {
      font-size: 12px;
      line-height: 1;
      color: var(--text-hl-branding-color);
      opacity: 0.7;
    }
  }
  &--menuitems {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .menuitem {
    a {
      font-size: 12px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-bottom: 18px;
      line-height: 1;
      gap: 0.25rem;
      color: var(--text-hl-branding-color);
      .menuitem--icon {
        transition: background-color 0.1s linear, border-color 0.1s linear, color 0.1s linear, opacity 0.1s linear;
        svg {
          transition: transform 0.1s linear;
        }
      }
    }
    &.active > a,
    a:hover {
      text-decoration: none;
      color: var(--text-hl-branding-color);
      .menuitem--icon {
        color: var(--text-hl-branding-color);
        opacity: 1;
        background: color-mix(in srgb, var(--light-branding-color) 50%, transparent);
        svg {
          transform: scale(1.15);
        }
      }
    }
    &--icon {
      width: 35px;
      height: 35px;
      padding: 0.25rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1rem;
      border-radius: $radiusMd;
    }
  }
}
</style>